// extracted by mini-css-extract-plugin
module.exports = {"placeholderStyle":"ResetPassword_placeholderStyle__5RE7T","inputStyle":"ResetPassword_inputStyle__1LmHI"};